<script setup lang="ts">
import type { InputPrimaryEvent } from '@shared/ui/fields'

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import { useIntroEditor } from '../../../model/assessments/intro-editor.hook'

defineOptions({
  name: 'IntroEditor',
})

const {
  refTitle,
  refDescription,
  setTitle,
  setDescription,
} = useIntroEditor()
</script>

<template>
  <section class="intro-editor">
    <AppText name="body1-medium">
      Intro screen
    </AppText>
    <AppText
      name="body2"
      color="slate-500"
    >
      What the student sees before they start. Separate from the template title above, which is
      the name tutors pick this assessment by — here the assessment gets to introduce itself.
    </AppText>

    <InputPrimary
      name="definitionTitle"
      label="Title shown to the student"
      :value="refTitle"
      placeholder="e.g. The Astronaut's Dilemma"
      @input="(event: InputPrimaryEvent) => setTitle(String(event.value ?? ''))"
    />

    <InputPrimary
      name="definitionDescription"
      type="textArea"
      label="Hook"
      optional-label="optional"
      :value="refDescription"
      placeholder="e.g. Did you know what it takes to become an astronaut?"
      @input="(event: InputPrimaryEvent) => setDescription(String(event.value ?? ''))"
    />
  </section>
</template>

<style scoped lang="scss" src="./IntroEditor.scss" />
